import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

const AnalyticsTracker: React.FC = () => {
    const location = useLocation();

    // Track page views on route changes
    useEffect(() => {
        if (window.gtag) {
            window.gtag('config', 'G-XH570S6L3N', {
                page_path: location.pathname + location.search + location.hash,
            });
        }
    }, [location]);

    // Global click listener for buttons and links
    useEffect(() => {
        const handleGlobalClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            // Find the closest button or link
            const clickableElement = target.closest('button, a');

            if (clickableElement && window.gtag) {
                const text = clickableElement.textContent?.trim().substring(0, 50) || 'unlabeled';
                const id = clickableElement.id;
                const type = clickableElement.tagName.toLowerCase();

                window.gtag('event', 'click', {
                    event_category: 'engagement',
                    event_label: `${type}: ${text}${id ? ` (#${id})` : ''}`,
                    element_id: id,
                    element_text: text,
                    element_type: type
                });
            }
        };

        document.addEventListener('click', handleGlobalClick);
        return () => {
            document.removeEventListener('click', handleGlobalClick);
        };
    }, []);

    return null; // This component doesn't render anything
};

export default AnalyticsTracker;
